import clsx from 'clsx';
import { Link as GatsbyLink } from 'gatsby';
import { HTMLProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type LinkVariant = 'primary' | 'inverse' | 'secondary' | 'secondaryInverse';

type Props = Omit<HTMLProps<HTMLAnchorElement>, 'href' | 'ref'> & {
  className?: string;
  href: string;
  variant?: LinkVariant;
};

export const Link = ({ children, className, href, variant = 'primary', ...linkProps }: Props) => {
  const isInternal = /^\/(?!\/)/.test(href);
  const file = /\.[0-9a-z]+$/i.test(href);

  const classNames = twMerge(
    clsx(
      'no-underline hover:underline focus:underline active:underline cursor-pointer',
      variant === 'primary' && 'text-primary-400 hover:text-primary-300 focus:text-primary-300 active:text-primary-300',
      variant === 'inverse' &&
        'text-secondary-50 hover:text-secondary-100 focus:text-secondary-100 active:text-secondary-100',
      variant === 'secondary' &&
        'text-primary-300 hover:text-primary-400 focus:text-primary-400 active:text-primary-400',
      variant === 'secondaryInverse' &&
        'text-secondary-100 hover:text-secondary-50 focus:text-secondary-50 active:text-secondary-50',
      className,
    ),
  );

  if (isInternal && !file) {
    return (
      <GatsbyLink className={classNames} to={href} {...linkProps}>
        {children}
      </GatsbyLink>
    );
  }

  if (href?.length > 0 && href[0] === '#') {
    return (
      <a
        className={classNames}
        {...linkProps}
        onClick={(e) => {
          linkProps.onClick && linkProps.onClick(e);
          const el = document.getElementById(href.replace('#', ''));
          const y = el ? el.getBoundingClientRect().top + window.scrollY - 100 : 0;
          window.scrollTo({ top: y });
        }}
      >
        {children}
      </a>
    );
  }

  return (
    <a className={classNames} href={href} {...linkProps}>
      {children}
    </a>
  );
};
